import { TitleWithIcon } from './TitleWithIcon';

export default TitleWithIcon;
